import { render, staticRenderFns } from "./TableAdminList.vue?vue&type=template&id=51472951&scoped=true"
import script from "./TableAdminList.vue?vue&type=script&lang=js"
export * from "./TableAdminList.vue?vue&type=script&lang=js"
import style0 from "./TableAdminList.vue?vue&type=style&index=0&id=51472951&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51472951",
  null
  
)

export default component.exports